import { render, staticRenderFns } from "./TruckInfoMeasurementFragment.vue?vue&type=template&id=65f04cab&scoped=true&"
import script from "./TruckInfoMeasurementFragment.vue?vue&type=script&lang=js&"
export * from "./TruckInfoMeasurementFragment.vue?vue&type=script&lang=js&"
import style0 from "./TruckInfoMeasurementFragment.vue?vue&type=style&index=0&id=65f04cab&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f04cab",
  null
  
)

/* custom blocks */
import block0 from "./TruckInfoMeasurementFragment.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports